import { apiSlice } from "../../app/api/apiSlice";

export const qrApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQrStats: builder.query({
      query: () => "/qr/stats",
      providesTags: ["QrStats"],
    }),

    getQrStatsByCode: builder.query({
      query: (code) => `/qr/stats/${code}`,
      providesTags: ["QrStats"],
    }),
  }),
});

export const { useGetQrStatsQuery, useGetQrStatsByCodeQuery } = qrApiSlice;
